import { resolveSiteUrl } from '@/utils/siteUrl';

export const DEFAULT_REDIRECT_PATH = '/app';
export type CallbackUrlType = 'default' | 'recovery';

const CALLBACK_PATH_BY_TYPE: Record<CallbackUrlType, string> = {
  default: '/auth/callback',
  recovery: '/reset-password'
};

const normalizeRedirectPath = (path?: string | null): string => {
  if (!path) {
    return DEFAULT_REDIRECT_PATH;
  }

  return path.startsWith('/') ? path : `/${path}`;
};

const buildBaseUrl = (type: CallbackUrlType): string => {
  const siteUrl = resolveSiteUrl();
  const path = CALLBACK_PATH_BY_TYPE[type];
  return `${siteUrl}${path}`;
};

export const buildCallbackUrl = (redirectPath: string | undefined, type: CallbackUrlType): string => {
  const baseUrl = buildBaseUrl(type);
  const target = normalizeRedirectPath(redirectPath);

  if (type === 'recovery') {
    const url = new URL(baseUrl);
    if (target !== DEFAULT_REDIRECT_PATH) {
      url.searchParams.set('redirect', target);
    }
    return url.toString();
  }

  if (target === DEFAULT_REDIRECT_PATH) {
    return baseUrl;
  }

  const callback = new URL(baseUrl);
  callback.searchParams.set('redirect', target);
  return callback.toString();
};

